export enum FieldEnum {
  TITLE = 'title__a',
  SUMMARY_FOR_CHANGES = 'summary_for_changes__a',
  REASON_FOR_CHANGES = 'reason_for_changes__a',
  IS_REVISION_OF_PRE_APPROVED_DOCUMENT = 'is_revision_of_pre_approved_document__a',
  FOLLOW_UP_COMMENT = 'follow_up_comment__a',
  CHECK_IN_COMMENT = 'check_in_comment__a',
  IS_GXP = 'is_gxp__a',
  IS_BIZ_ADMIN_APPROVAL_REQUIRED = 'is_biz_admin_approval_required__a',
  IS_TRAINABLE = 'is_trainable__a',
  IS_LOCKED = 'is_locked__a',
  FOLLOW_UP_APPROVAL_DUE_DATE = 'follow_up_approval_due_date__a',
  FOLLOW_UP_APPROVAL_DATE = 'follow_up_approval_date__a',
  CERTIFICATE_ID = 'certificate_id__a',
  APPROVAL_DUE_DATE = 'approval_due_date__a',
  FOLLOW_UP_REQUIRED = 'follow_up_required__a',
  INITIATION_DATE = 'initiation_date__a',
  IS_ORIGINAL = 'is_original__a',
  COLLABORATION_DUE_DATE = 'collaboration_due_date__a',
  APPROVED_DATE = 'approved_date__a',
  IS_OBSOLETE_APPROVED = 'is_obsolete_approved__a',
  PROPOSED_EFFECTIVE_DATE = 'proposed_effective_date__a',
  OBSOLETE_JUSTIFICATION = 'obsolete_justification__a',
  CANCEL_JUSTIFICATION = 'cancel_justification__a',
  IS_UPLOADED_DOCUMENT_ELECTRONIC_COPY = 'is_uploaded_document_electronic_copy__a',
  EFFECTIVE_DATE = 'effective_date__a',
  FOLLOW_UP_DECISION_DATE = 'follow_up_decision_date__a',
  FOLLOW_UP_DUE_DATE = 'follow_up_due_date__a',
  FOLLOW_UP_TRIGGER_DATE = 'follow_up_trigger_date__a',
  PROPOSED_OBSOLETION_DATE = 'proposed_obsoletion_date__a',
  OBSOLETION_DATE = 'obsoletion_date__a',
  SUPERSEDED_DATE = 'superseded_date__a',
  DOCUMENT_STATUS = 'document_status__a',
  FOLLOW_UP_ACTION = 'follow_up_action__a',
  INITIATION_TYPE = 'initiation_type__a',
  GXP_TYPES = 'gxp_types__a',
  DOCUMENT_TYPE = 'document_type__a',
  DOCUMENT_SUB_TYPE = 'document_sub_type__a',
  DEPARTMENT = 'department__s',
  REQUIRED_APPROVERS = 'required_approvers__a',
  COLLABORATORS = 'collaborators__a',
  QUALITY_APPROVERS = 'quality_approvers__a',
  REQUESTOR = 'requestor__a',
  OWNER = 'owner__a',
  LAST_CHECKED_IN_BY_USER = 'last_checked_in_by_user__a',
  LAST_CHECKED_OUT_BY_USER = 'last_checked_out_by_user__a',
  REFERENCE_DOCUMENTS = 'reference_documents__a',
  SHOULD_REPLACE_HEADER_FOOTER = 'should_replace_header_footer__a',
  FOLLOW_UP_FREQUENCY_IN_MONTHS = 'follow_up_frequency_in_months__a',
  FOLLOW_UP_TRIGGER_PERIOD_IN_DAYS = 'follow_up_trigger_period_in_days__a',
  EFFECTIVENESS_IN_DAYS = 'effectiveness_in_days__a',
  FILE = 'file__a',
  ATTACHMENTS = 'attachments__a',
  NAME = 'name__a',
  LABEL = 'label__s',
  OWNER_TYPE = 'owner_type__a',
  VERSION = 'version__s',
  IS_SUBMITTED = 'is_submitted__s',
  IS_RAW_FILE_DOWNLOAD_ALLOWED = 'is_raw_file_download_allowed__a',
  ID = 'id__s',
  CREATED_AT_UTC = 'created_at_utc__a',
  MODIFIED_AT_UTC = 'modified_at_utc__a',
  CREATED_BY_USER = 'created_by_user__a',
  MODIFIED_BY_USER = 'modified_by_user__a',
  DELETED_AT_UTC = 'deleted_at_utc__a',
  IS_ACTIVE = 'is_active__s',
  LIFECYCLE_STAGE = 'lifecycle_stage__s',
  IS_GOVERNING_DOCUMENT_REQUIRED = 'is_governing_document_required__a',
  GOVERNING_DOCUMENT_ID = 'governing_document_id__a',

  // Document
  DOCUMENT = 'document__a',
}
